import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import getDefaultValues from '../../../admin-on-rest/src/mui/form/getDefaultValues';
import { CardTitle } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import GiftCardIcon from "./Icons/GiftCardIcon.js";

import {Toolbar, ToolbarGroup} from "material-ui/Toolbar";

import {
	translate,
	Title,
	showNotification as showNotificationAction,
  refreshView as refreshViewAction
} from "admin-on-rest";

import {giftCardSimpleForm} from "./style";

import RadioButtonGroupInput from "./RadioButtonGroupInput";
import FormInput from "./FormInput";

import restClient from "../../../restClient";
import TextField from "../TextField";

import {BMTheme} from "../../../BMTheme";


export class SimpleForm extends Component {
	state = {
		disabledInputFields: false,
		date: null,
		kiosk_id: null,
		customerRecord: null,
    isLoading: false
	};

	componentDidMount() {
		let d = new Date();
		let dateString = d.getUTCDate() +"/"+ (d.getUTCMonth()+1) +"/"+ d.getUTCFullYear();
		this.setState({ date: dateString });

		const kiosk = JSON.parse(localStorage.getItem("kiosk"));
    const kiosk_id = kiosk ? kiosk.id : '';
		this.setState({ kiosk_id: kiosk_id });
		
		this.getCustomer();
	}

	getCustomer() {    
		if(this.props.data){
			restClient("GET_ONE", "customers", {
				id: this.props.data.customer_id
			}).then(({data}) => {
				this.setState({
					customerRecord: data
				});
			})
			.catch(err => {
				console.error(err);
			});
		}    
  }

	handleSubmit(values) {
		this.setState({isLoading: true});

		values.state = "processing";
		this.props.save(values, 'list');

		// let data = {
		// 	state: "processing",
		// 	value: values.value,
		// 	promo_id: values.promo_id
		// };
		
		// restClient(UPDATE, "gift_cards", {
    //   id: values.id,
    //   data: data,
		// 	redirectTo: 'list',
    //   previousData: values
    // })
		// .then(() => {
		// 	this.setState({isLoading: false, disabledInputFields: true});
		// 	showNotification("aor.notification.updated");
		// 	this.props.refreshView();
		// })
		// .catch(error => {
		// 	showNotification(error.message, "warning");
		// });
		
	}

	render() {
		const {
			basePath,
			record,
			resource,
			giftCardForm,
			title,
			kioskPromos,
			translate
		} = this.props;
		
		var textFields = null;
		if(this.state.customerRecord){
			let createdAt = this.props.data.created_at;

			let d = new Date(createdAt);
			let dateString = d.getUTCDate() +"/"+ (d.getUTCMonth()+1) +"/"+ d.getUTCFullYear();
			let dateObj = {
				created_at: dateString
			}			

			textFields = <div>
				<TextField elStyle={giftCardSimpleForm.customerInputs} record={this.state.customerRecord} source="phone" />
				<TextField elStyle={giftCardSimpleForm.customerInputs} record={this.state.customerRecord} source="first_name" />
				<TextField elStyle={giftCardSimpleForm.customerInputs} record={this.state.customerRecord} source="last_name" />
				{this.state.customerRecord.email && <TextField elStyle={giftCardSimpleForm.customerInputs} record={this.state.customerRecord} source="email" />}
				<TextField elStyle={giftCardSimpleForm.customerInputs} record={dateObj} source="created_at" />
			</div>
		}
		
		var promosRadioGroup = (record && kioskPromos) ? [
			<RadioButtonGroupInput source="promo_id" choices={kioskPromos} disabled={this.state.disabledInputFields} />
		] : null;
		
		var valuesRadioGroup = [
			<RadioButtonGroupInput source="value" choices={[
				{ id: 10000, name: "100,00" },
				{ id: 25000, name: "250,00" },
				{ id: 50000, name: "500,00" },
				{ id: 100000, name: "1000,00" },
				{ id: 200000, name: "2000,00" }
			]} disabled={this.state.disabledInputFields} />
		];

		const customerTranslation = translate("resources.giftCards.customer");

		const TITLE = this.state.customerRecord ? <span>{title} - <span style={giftCardSimpleForm.customerTitle}>{customerTranslation}: <span style={{ color: BMTheme.palette.primary1Color }}>{this.state.customerRecord.phone}</span></span></span> : title;

		const titleElement = (
			<Title title={TITLE} defaultTitle="" />
		);

		const radioButtonsPromosTitleElement = (
			<Title title={translate("resources.giftCards.promosLabel")} defaultTitle="" />
		);
		const radioButtonsValuesTitleElement = (
			<Title title={translate("resources.giftCards.valuesLabel")} defaultTitle="" />
		);
		
		const titleStyle = {
			borderBottom: "3px solid #E7E7E7"
		}

		return (
			<React.Fragment>
				
				<form onSubmit={this.props.handleSubmit(this.handleSubmit.bind(this))} className="simple-form gift-card-form">
					
						<div style={giftCardSimpleForm.inputsContainer} className="person-inputs-container">
							<CardTitle title={titleElement} className="title" style={titleStyle} />
							
							{textFields}
							
							<div style={giftCardForm.clearFloatContainer} />
						</div>
						
						<div 
							style={
								{
									...giftCardSimpleForm.inputsContainerNoMargin, 
									borderTop: "5px solid", 
									borderColor: BMTheme.palette.primary1Color, 
									borderTopLeftRadius: "3px", 
									borderTopRightRadius: "3px"
								}} 
							className="person-inputs-container"
						>
							<div style={giftCardSimpleForm.radioButtonsContainer}>
								<CardTitle 
									title={radioButtonsPromosTitleElement} 
									className="title" 
									style={{
										...titleStyle,
										padding: 10,
										borderRight: "1px solid #E7E7E7"
									}} 
								/>
								
								{(record && kioskPromos) ? promosRadioGroup.map(
									(input, index) => {
										return <FormInput
											key={index}
											basePath={basePath}
											input={input}
											record={record}
											resource={resource}
										/>;
									}
								): null}
							</div>
							
							<div style={giftCardSimpleForm.radioButtonsContainer}>
								<CardTitle 
									title={radioButtonsValuesTitleElement} 
									className="title" 
									style={{
										...titleStyle,
										padding: 10,
										borderLeft: "1px solid #E7E7E7"
									}} 
								/>
								
								{valuesRadioGroup.map(
									(input, index) => {
										return <FormInput
											key={index}
											basePath={basePath}
											input={input}
											record={record}
											resource={resource}
										/>;
									}
								)}
							</div>
							<div style={giftCardForm.clearFloatContainer} />

							{this.props.data && this.props.data.state === 'new' && this.props.giftCardsEnabled && <Toolbar  style={{ justifyContent: "flex-end" }}>
								<ToolbarGroup>
									<FlatButton
										type="submit"
										label={translate("resources.giftCards.activateButton")}
										icon={<GiftCardIcon />}
										primary
										style={giftCardSimpleForm.giftCardButton}
										disabled={this.props.data && this.props.data.state !== 'new'}
									/>
								</ToolbarGroup>						
							</Toolbar>}
						</div>					
				</form>
			
			</React.Fragment>
		);
	}
}

SimpleForm.propTypes = {
	basePath: PropTypes.string,
	children: PropTypes.node,
	defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
	handleSubmit: PropTypes.func, // passed by redux-form
	invalid: PropTypes.bool,
	record: PropTypes.object,
	resource: PropTypes.string,
	redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
	submitOnEnter: PropTypes.bool,
	toolbar: PropTypes.element,
	translate: PropTypes.func,
	validate: PropTypes.func,
	version: PropTypes.number
};

SimpleForm.defaultProps = {
	submitOnEnter: true,
	toolbar: <Toolbar />,
};

const enhance = compose(
	connect((state, props) => ({
		record: state.admin.resources[props.resource],
		initialValues: getDefaultValues(state, props),
		giftCardsEnabled: state.giftCards.giftCardsEnabled
	}),
	{
    showNotification: showNotificationAction,
		refreshView: refreshViewAction
  }),
	translate,
	reduxForm({
		form: 'record-edit-form',
		enableReinitialize: true,
	})
);

export default enhance(SimpleForm);



// WEBPACK FOOTER //
// ./src/components/CRM/Form/SimpleEditGiftCardForm.js